module.exports = __webpack_public_path__ + "img/get-started.516b1794.svg";